import DOMPurify from "isomorphic-dompurify";
import { getWarehouseFilterParams } from "../../../../utils/warehouses/findAWarehouse.lib.js";
import { LOCATION_SEARCH_PARAM_KEY } from "../../../../utils/warehouses/warehouseDrawer.constants.js";
const sanitizeInput = (input) => {
  return typeof window !== "undefined" ? DOMPurify.sanitize(input) : "";
};
const getWarehouseLocationsUrl = (formValues, drawerOptionsDetails, warehousePageBaseUrl) => {
  const params = new URLSearchParams();
  if (formValues.searchText) {
    params.append(
      LOCATION_SEARCH_PARAM_KEY,
      sanitizeInput(formValues.searchText)
    );
  }
  const warehouseFilters = getWarehouseFilterParams(
    drawerOptionsDetails,
    formValues.filters,
    "warehouseLocationsPage"
  );
  for (const [key, value] of Object.entries(warehouseFilters)) {
    if (value === true) {
      params.append(key, "true");
    }
  }
  const separator = warehousePageBaseUrl.includes("?") ? "&" : "?";
  return `${warehousePageBaseUrl}${separator}${params.toString()}`;
};
export {
  getWarehouseLocationsUrl
};
